module.exports = __webpack_public_path__ + "media/images/icons/outlined/redo-cba89a553a6886d525cd7eea68e3227a.svg";